// AssistantSendButton — the composer's send control. Same circle as its
// sibling icon buttons (`controlHCompact`, so the whole composer bar sits on
// ONE centre line), two honest states declared on the primitive (Rule 65):
//
//   resting  — a quiet disc of the field's own ink (Rule 67's `color-mix` on
//              currentColor) with `inactive` ink: the button is present but
//              there is nothing to send yet. Measured live 2026-09-10: the
//              `overlayStrong` token painted rgba(20,20,22,.98) on the dark
//              field — a near-black disc on near-black, invisible.
//   ready    — `theme: 'primary'`, the brand's SOLID-INK action (white on the
//              dark shell, black on the light one). A hue fill never marks a
//              primary action in the chrome register.
//
// The mount site decides WHEN it is ready (`isReady`) and what happens on
// click; it never restates the geometry.
export const AssistantSendButton = {
  extends: 'NavbarButton',
  boxSize: 'controlHCompact',
  minWidth: 'controlHCompact',
  boxSizing: 'border-box',
  padding: '0',
  round: 'radiusPill',
  align: 'center center',
  flexShrink: '0',
  border: 'none',
  style: { background: 'color-mix(in srgb, currentColor 12%, transparent)' },
  color: 'inactive',
  cursor: 'default',
  transition: 'A defaultBezier',
  transitionProperty: 'background-color, color, transform',
  '.isReady': {
    theme: 'primary',
    cursor: 'pointer',
    ':hover': { transform: 'translateY(-1px)' },
    ':active': { transform: 'translateY(0)' }
  },
  Icon: { boxSize: 'iconMd', display: 'block', flexShrink: '0', color: 'inherit' }
}
